module.exports = __webpack_public_path__ + "img/measurement_info_back_band_left.fc16b9ef.jpg";